<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>¿Dónde entregamos la tarjeta?</label> 
                    </div>
                </div>   

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Podemos enviarla a tu domicilio o si preferís a otra dirección donde te sea más comodo recibirla</label> 
                    </div>
                </div>   
                <div class="text-center" style="margin-top:10px;margin-bottom:30px;">
                    <img src="@/assets/entrega.png" class="mx-auto d-block" width="10%" height="10%" />
                </div>

                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="A mi domicilio" @click="aMiDomicilio"></save-button>
                        <save-button text="A otra dirección" @click="aOtraDireccion"></save-button>
                    </div>
                </div>

            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>

    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';

    export default {
        data(){
            return{
            }
        },
        methods: {
            aMiDomicilio() {
                let context = this;
                context.$router.push("FinishCardGeneration");
            },
            aOtraDireccion() {
                let context = this;
                context.$router.push("AddAnotherAddress");
            }
        }
    }
</script>